export const SCANNER_TYPE = {
  RESULTS: "results",
  INFO_PENDING: "info_pending",
  ANALYSIS_PENDING: "analysis_pending",
} as const;
export type ScannerType = (typeof SCANNER_TYPE)[keyof typeof SCANNER_TYPE];

export type ScannerTypeForAPI = "results" | "info-pending" | "analysis-pending";
export const SCANNER_TYPES_FOR_API: { [k in ScannerType]: ScannerTypeForAPI } =
  {
    [SCANNER_TYPE.RESULTS]: "results",
    [SCANNER_TYPE.INFO_PENDING]: "info-pending",
    [SCANNER_TYPE.ANALYSIS_PENDING]: "analysis-pending",
  } as const;

export const SCANNER_TAB_ICONS = {
  [SCANNER_TYPE.RESULTS]: "mdi-progress-check",
  [SCANNER_TYPE.INFO_PENDING]: "mdi-progress-clock",
  [SCANNER_TYPE.ANALYSIS_PENDING]: "mdi-progress-alert",
} as const;
